"use strict";
/** state: Final **/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var lodash_1 = require("lodash");
var React = require("react");
var CLASS_NAME = 'i-boundary';
var CONTAINER_CLASS_NAME = CLASS_NAME + "__container";
var CHILD_CLASS_NAME = CLASS_NAME + "__child";
/**
 * The Boundary component is used to translate the position of its children, relative
 * to the size of the container, but not allow the child to appear outside. The Boundary
 * component will center the child both horizontally and vertically if the Boundary
 * dimensions exceed the child dimensions.
 *
 * The offset percentages are calculated relative to the container width, using the center
 * point of both the container and child.
 */
var Boundary = /** @class */ (function (_super) {
    __extends(Boundary, _super);
    function Boundary(props) {
        var _this = _super.call(this, props) || this;
        _this.isMounting = true;
        _this.boundaryRef = React.createRef();
        _this.containerRef = React.createRef();
        _this.childRef = React.createRef();
        _this.getStyles = function () {
            var offsets = _this.getBoundOffsets();
            return {
                container: {
                    transform: "\n                    translateX(" + offsets.x * 100 + "%)\n                    translateY(" + offsets.y * 100 + "%)\n                ",
                },
            };
        };
        _this.getBoundOffsets = function () {
            var _a = _this.props, xOffset = _a.xOffset, yOffset = _a.yOffset;
            var boundary = _this.boundaryRef.current;
            var child = _this.childRef.current;
            if (boundary && child) {
                var boundaryRect = boundary.getBoundingClientRect();
                var childRect = child.getBoundingClientRect();
                var childWidthPercent = childRect.width / boundaryRect.width;
                var childHeightPercent = childRect.height / boundaryRect.height;
                return {
                    x: _this.clampValue(xOffset, -0.5 + childWidthPercent / 2, 0.5 - childWidthPercent / 2),
                    y: _this.clampValue(yOffset, -0.5 + childHeightPercent / 2, 0.5 - childHeightPercent / 2),
                };
            }
            return {
                x: 0,
                y: 0,
            };
        };
        _this.clampValue = function (value, min, max) {
            return Math.min(Math.max(value, min), max);
        };
        _this.handleWindowResize = function () {
            _this.forceUpdate();
        };
        _this.handleWindowResize = lodash_1.throttle(_this.handleWindowResize, 25);
        return _this;
    }
    Boundary.prototype.componentDidMount = function () {
        window.addEventListener('resize', this.handleWindowResize);
        this.isMounting = false;
        /**
         * Trigger a secondary render once the component has been mounted. This is
         * necessary because we hide the component while it is mounting, as is
         * required that the component is mounted to correctly calculate the bounded
         * x and y offsets.
         */
        this.forceUpdate();
    };
    Boundary.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.handleWindowResize);
    };
    Boundary.prototype.render = function () {
        var _a;
        var _b = this.props, children = _b.children, className = _b.className, 
        // omit
        yOffset = _b.yOffset, xOffset = _b.xOffset, restProps = __rest(_b, ["children", "className", "yOffset", "xOffset"]);
        var styles = this.getStyles();
        return (React.createElement("div", __assign({ className: classNames(CLASS_NAME, className, (_a = {},
                _a[CLASS_NAME + "--mounting"] = this.isMounting,
                _a)), ref: this.boundaryRef }, restProps),
            React.createElement("div", { className: CONTAINER_CLASS_NAME, ref: this.containerRef, style: styles.container },
                React.createElement("div", { className: CHILD_CLASS_NAME, ref: this.childRef }, children))));
    };
    Boundary.defaultProps = {
        xOffset: 0,
        yOffset: 0,
    };
    return Boundary;
}(React.Component));
exports.Boundary = Boundary;
//# sourceMappingURL=Boundary.js.map